$(document).ready(function () {

    $('.js-careers-more').on('click', function () {

        if ($(this).closest('.js-careers-card').find('.js-careers-additional').is(':visible')) {
            $(this).closest('.js-careers-card').find('.js-careers-additional').slideUp();
            $('.js-careers-card').removeClass('flexing');
        } else {
            $('.js-careers-additional').slideUp();
            $(this).closest('.js-careers-card').find('.js-careers-additional').slideDown();
            $('.js-careers-card').addClass('flexing');
        }

    });

});